import _extends from "@babel/runtime/helpers/esm/extends";
var _path, _path2;
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SvgHide = function SvgHide(props) {
  return /*#__PURE__*/_jsxs("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: [_path || (_path = /*#__PURE__*/_jsx("path", {
      d: "m2.375 2.375 11.25 11.25M7.115 7.117a1.25 1.25 0 1 0 1.768 1.769",
      stroke: "currentColor",
      strokeWidth: 1.3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
      d: "M11.348 11.343A5.862 5.862 0 0 1 8 12.375c-2.5 0-4.583-1.458-6.25-4.375.856-1.497 1.82-2.61 2.895-3.338m1.707-.809A5.916 5.916 0 0 1 8 3.625c2.5 0 4.583 1.458 6.25 4.375-.486.85-1.008 1.578-1.564 2.18L6.352 3.853Z",
      stroke: "currentColor",
      strokeWidth: 1.3,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }))]
  }));
};
export default SvgHide;